// extracted by mini-css-extract-plugin
export default {"outer":"TheDaoDark_outer__Uobn-","dao_right":"TheDaoDark_dao_right__CBpeo","dao_p":"TheDaoDark_dao_p__VBadg"};